import { render } from "./v-file-picker.vue?vue&type=template&id=f470c712&scoped=true"
import script from "./v-file-picker.vue?vue&type=script&lang=js"
export * from "./v-file-picker.vue?vue&type=script&lang=js"

import "./v-file-picker.vue?vue&type=style&index=0&id=f470c712&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f470c712"]])

export default __exports__